<template>
  <div class="detail-wrap">
    <div class="left">
      <el-card shadow="never">
        <div class="avatar">
          <img src="./avatar.jpg" alt="" />
          <h1>
            {{ customerInfo.name }}
            {{ customerInfo.code }}
          </h1>
          <p style="margin-bottom: 20px">
            {{ customerInfo.address }},{{ customerInfo.city }},{{
              customerInfo.state
            }},{{ customerInfo.countryStr }}
          </p>
          <el-row
            type="flex"
            :gutter="20"
            justify="center"
            v-if="$store.state.source !== 2"
          >
            <el-col
              :span="8"
              v-for="item in customerTypeList"
              :key="item.companyId"
            >
              <el-button
                :type="
                  item.companyId === $route.params.customerId ? 'primary' : ''
                "
                size="small"
                @click="handleClickCustomer(item.companyId)"
              >
                {{ getCustomerType(item.customerType) }}
              </el-button>
            </el-col>
          </el-row>
        </div>
        <div class="menu-list">
          <template v-for="item in leftMenu">
            <a
              href="javascript:void (0)"
              class="menu-item"
              :class="{ 'menu-item-active': isActiveItem === item.url }"
              :key="item.label"
              v-if="!item.children"
              @click="handleJump(item.url)"
            >
              <span class="icon-warp">
                <i :class="item.icon" class="icon" />
              </span>
              <span class="title">{{ item.name }}</span>
            </a>
            <div class="child-container" v-else :key="item.label">
              <div
                class="menu-item"
                :class="{
                  'menu-item-active': isActiveItem.indexOf('info') !== -1,
                }"
              >
                <span class="icon-warp">
                  <i :class="item.icon" class="icon" />
                </span>
                <span class="title">{{ item.name }}</span>
              </div>
              <ul
                class="child-warp"
                :class="{
                  'child-wrap-active': isActiveItem.indexOf('info') !== -1,
                }"
              >
                <li
                  v-for="child in item.children"
                  :key="child.label"
                  class="child-item"
                >
                  <router-link
                    :class="{
                      'child-item-active': isActiveItem === child.to,
                    }"
                    :to="`/customer-management/${$route.params.customerId}/${child.url}`"
                  >
                    {{ child.name }}
                  </router-link>
                </li>
              </ul>
            </div>
          </template>
        </div>
      </el-card>
    </div>
    <div class="right">
      <router-view />
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { getCompanyInfo } from './info/snapshot/api'
export default {
  data() {
    return {
      leftMenu: [
        {
          label: 'Customer Infomation',
          icon: 'icon-file',
          children: [
            {
              label: 'Customer Snapshot',
              to: 'info/snapshot',
            },
            {
              label: 'Customer Basic Profile',
              to: 'info/basic-profile',
            },
            {
              label: 'Credit Trend',
              to: 'info/credit-trend',
            },
            {
              label: 'Credit Line',
              to: 'info/credit-line',
            },
            {
              label: 'Collateral',
              to: 'info/collateral',
            },
            {
              label: 'Insurance',
              to: 'info/insurance',
            },
            {
              label: 'AR data',
              to: 'info/ar-data',
            },
            {
              label: 'Notes',
              to: 'info/notes',
            },
          ],
        },
        {
          label: 'Financial Report',
          icon: 'icon-demo',
          to: 'financial-report',
        },
        {
          label: 'Credit Methodology',
          icon: 'icon-credit',
          to: 'credit-method',
        },
        {
          label: 'Bureau Report',
          icon: 'icon-clipboard',
          to: 'bureau-report',
        },
        {
          label: 'Scores',
          icon: 'icon-chart',
          to: 'scores',
        },
        {
          label: 'Business Hierarchy',
          icon: 'icon-building',
          to: 'business-hierarchy',
        },
        {
          label: 'Financial Analysis',
          icon: 'icon-pie1',
          to: 'financial-analysis',
        },
        {
          label: 'TnC Details',
          icon: 'icon-creatdoc',
          to: 'tnc-details',
        },
      ],
      customerInfo: [],
      customerTypeList: [],
      isActiveItem: '',
    }
  },
  watch: {
    $route: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const arr = newValue.path.split('/')
        if (arr.length > 4) {
          this.isActiveItem = `${arr[3]}/${arr[4]}`
        } else {
          this.isActiveItem = arr[arr.length - 1]
        }
      },
    },
    customerTypeList: {
      immediate: true,
      handler(val) {
        if (val && val.length) {
          const currentCustomer = val.find(
            item => item.companyId === this.$route.params.customerId,
          )
          if (currentCustomer) {
            const customerType = this.getCustomerType(
              currentCustomer.customerType,
            )
            this.$store.commit('SET_CUSTOMER_TYPE', customerType)
          }
        }
      },
    },
  },
  mounted() {
    this.getMenus()
    this._getCompanyInfo()
  },
  created() {},
  beforeDestroy() {
    document.title = 'Lenovo Credit Platform'
  },
  methods: {
    handleClickCustomer(id) {
      // 如果点击的 ID 与当前路由的 ID 相同，则不执行跳转
      if (id === this.$route.params.customerId) {
        return
      }

      // 构建新的路由对象
      const newRoute = {
        name: this.$route.name, // 保持当前路由的名称
        params: { ...this.$route.params, customerId: id },
        query: this.$route.query, // 保留当前的查询参数
      }

      // 使用 router.resolve 生成完整的 URL
      const resolvedRoute = this.$router.resolve(newRoute)

      // 在新标签页中打开 URL
      window.open(resolvedRoute.href, '_blank')
    },
    getCustomerType(type) {
      switch (type) {
        case 1:
          return 'Trade'
        case 2:
          return 'Eaas'
        case 3:
          return 'Saas'
        default:
          return ''
      }
    },
    async _getCompanyInfo() {
      const res = await getCompanyInfo(this.$route.params.customerId)
      this.customerInfo = res.companyInfoVO
      this.customerTypeList = res.customerTypeList
      this.$store.commit('setCustomerTypeList', res.customerTypeList)
      document.title = this.customerInfo.name
    },
    async getMenus() {
      try {
        this.leftMenu = await request.get('/masterdata-api/menu/customer/list')
      } catch (e) {
        console.error(e)
      }
    },
    async handleJump(url) {
      if (url !== '#') {
        if (url === 'creditRequests') {
          const res = await getCompanyInfo(this.$route.params.customerId)
          this.customerInfo = res.companyInfoVO
          if (res.companyInfoVO.sourceStr === 'CSS') {
            this.$router.push(
              `/credit-management/css-request/${this.$route.params.customerId}/detail`,
            )
          } else {
            this.$router.push(
              `/credit-management/credit-request/${this.$route.params.customerId}/detail`,
            )
          }
        } else {
          this.$router.push(
            `/customer-management/${this.$route.params.customerId}/${url}`,
          )
        }
      }
    },
  },
}
</script>

<style scoped lang="less">
.box-shadow {
  box-shadow: 0 4px 16px 0 rgba(179, 192, 231, 0.32);
}

.detail-wrap {
  display: flex;

  .left {
    width: 320px;
    margin-right: 24px;

    .avatar {
      text-align: center;
      margin-bottom: 40px;

      h1 {
        font-size: 16px;
        color: #3a3f63;
        line-height: 24px;
        font-weight: 700;
        margin-top: 16px;
      }
      p {
        font-size: 14px;
        color: #9c9da2;
        line-height: 24px;
        margin-top: 16px;
      }
    }

    .menu-list {
      .menu-item {
        display: flex;
        box-sizing: border-box;
        width: 272px;
        height: 56px;
        background: #fff;
        border-radius: 4px;
        margin-bottom: 8px;
        padding-left: 8px;
        align-items: center;
        cursor: pointer;

        &:hover {
          .menu-item-active();
        }

        .title {
          font-size: 14px;
          color: #2b2f42;
          font-weight: 400;
          margin-left: 24px;
        }

        .icon-warp {
          display: flex;
          width: 40px;
          height: 40px;
          background: #f4f7ff;
          border-radius: 8px;
          text-align: center;
          justify-content: center;
          align-items: center;

          .icon {
            font-size: 20px;
            color: #b3c0e7;
          }
        }

        .child-warp {
          display: block;
        }
      }

      .menu-item-active {
        .box-shadow();
        .icon-warp {
          background-image: linear-gradient(46deg, #fe7301 0%, #e41e20 100%);

          .icon {
            color: #fff;
          }
        }
      }

      .child-container {
        margin-bottom: 20px;
        &:hover {
          .child-warp {
            .box-shadow();
          }

          .menu-item {
            .menu-item-active();
          }
        }
      }
    }

    .child-warp {
      padding-left: 72px;

      a {
        display: block;
        height: 40px;
        font-size: 14px;
        color: #222653;
        line-height: 40px;
        font-weight: 400;
      }

      .child-item {
        a:hover {
          .child-item-active();
        }
      }
      .child-item-active {
        color: #4458fe;
        font-weight: 400;
      }
    }

    .child-wrap-active {
      .box-shadow();
    }
  }

  .right {
    width: calc(100% - 320px);
  }
}
</style>
